export default {
	"7e0a306dfb7bfac0f8b9e40ca3f9530b": "我知道了"
}
